import { makeStyles } from "@material-ui/styles";

const teamPlayersContainerStyles = makeStyles((theme) => ({
	buttonContainer: {
		minWidth: 397,
		justifyContent: "flex-end",
		[theme.breakpoints.only("xs")]: {
			minWidth: 300,
			justifyContent: "flex-start"
		}
	},
	titleBox: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(1),
		"& button": {
			maxWidth: "fit-content"
		}
	}
}));

export default teamPlayersContainerStyles;
